var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6838 3.71343L5.68377 5.71343C5.27543 5.84954 5 6.23168 5 6.66211V11.9998C5 14.0255 6.01463 15.7552 7.48432 17.2095C8.95718 18.6669 10.7303 19.6838 11.8268 20.2264C11.9405 20.2826 12.0595 20.2826 12.1731 20.2264C13.2697 19.6838 15.0428 18.6669 16.5157 17.2095C17.9854 15.7552 19 14.0255 19 11.9998V6.66211C19 6.23168 18.7246 5.84954 18.3162 5.71343L12.3162 3.71343C12.111 3.645 11.889 3.645 11.6838 3.71343ZM5.05132 3.81606C3.82629 4.2244 3 5.37082 3 6.66211V11.9998C3 17.5018 8.56019 20.8416 10.9399 22.019C11.6125 22.3518 12.3875 22.3518 13.0601 22.019C15.4398 20.8416 21 17.5018 21 11.9998V6.66211C21 5.37082 20.1737 4.2244 18.9487 3.81606L12.9487 1.81606C12.3329 1.61079 11.6671 1.61079 11.0513 1.81606L5.05132 3.81606Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L12.2728 14.1414C11.5698 14.8444 10.4302 14.8444 9.72721 14.1414L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldBold);
export default __webpack_public_path__ + "static/media/shield-bold.e6b4fd9391c572bfda4e8532b9ce00ba.svg";
export { ForwardRef as ReactComponent };